<h2 class="header">
  <div>{{ data.payload.title }}</div>
  <rx-icon name="close" class="dark" (click)="closePopup()"></rx-icon>
</h2>

<div class="btn-wrapper" *ngFor="let button of buttons">
  <button class="btn" (click)="login(button)">{{ button.name }}</button>
</div>
